import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Snackbar, Alert, AlertTitle } from '@mui/material'
import { selectNotifications, removeNotification } from '../store/slices/notificationsSlice'

const NotificationBanner = () => {
  const notificationsList = useSelector(selectNotifications)
  const dispatch = useDispatch()
  const [currentNotification, setCurrentNotification] = useState(null)

  useEffect(() => {
    const notification = notificationsList.find(notif => notif.show)
    if (notification && (!currentNotification || currentNotification.id !== notification.id)) {
      setCurrentNotification(notification)
    }
  }, [notificationsList, currentNotification])

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    if (currentNotification) {
      dispatch(removeNotification(currentNotification.id))
      setCurrentNotification(null)
    }
  }

  if (!currentNotification) {
    return null
  }

  const severity = currentNotification.iconColor === 'error' ? 'error' : 'info'

  return (
    <Snackbar
      open={!!currentNotification}
      autoHideDuration={currentNotification.timeout || 4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        <AlertTitle>Entry {currentNotification.id}</AlertTitle>
        {currentNotification.subtitle}
      </Alert>
    </Snackbar>
  )
}

export default NotificationBanner